import { findBlock, findColumn, findGroup, findRow } from "../find";
import type { EmailDocument, Selection } from "../types";

export function resolveSelection(
  doc: EmailDocument,
  selection: Selection,
): Selection {
  if (selection.kind === 'email') {
    return selection;
  }
  if (selection.kind === 'group') {
    return findGroup(doc.sections, selection.groupId)
      ? selection
      : { kind: 'email' };
  }
  if (selection.kind === 'row') {
    return findRow(doc, selection.rowId) ? selection : { kind: 'email' };
  }
  if (selection.kind === 'column') {
    if (findColumn(doc, selection.rowId, selection.columnId)) {
      return selection;
    }
    if (findRow(doc, selection.rowId)) {
      return { kind: 'row', rowId: selection.rowId };
    }
    return { kind: 'email' };
  }
  if (selection.kind === 'block') {
    if (
      findBlock(doc, selection.rowId, selection.columnId, selection.blockId)
    ) {
      return selection;
    }
    if (findColumn(doc, selection.rowId, selection.columnId)) {
      return {
        kind: 'column',
        rowId: selection.rowId,
        columnId: selection.columnId,
      };
    }
    if (findRow(doc, selection.rowId)) {
      return { kind: 'row', rowId: selection.rowId };
    }
    return { kind: 'email' };
  }
  if (selection.kind === 'buttonRowSlot') {
    const block = findBlock(
      doc,
      selection.rowId,
      selection.columnId,
      selection.blockId,
    );
    if (
      block?.type === 'buttonRow' &&
      selection.slotIndex >= 0 &&
      selection.slotIndex < block.buttons.length
    ) {
      return selection;
    }
    if (block) {
      return {
        kind: 'block',
        rowId: selection.rowId,
        columnId: selection.columnId,
        blockId: selection.blockId,
      };
    }
    if (findColumn(doc, selection.rowId, selection.columnId)) {
      return {
        kind: 'column',
        rowId: selection.rowId,
        columnId: selection.columnId,
      };
    }
    if (findRow(doc, selection.rowId)) {
      return { kind: 'row', rowId: selection.rowId };
    }
    return { kind: 'email' };
  }
  return { kind: 'email' };
}
